import request from "./http";


//>获取树形架构
export function getRateTree() {
    return request({
        url: "/rate/findUnitTreeIsTem",
        method: "get",
    });
}

//绑定模板
export function getRateBindingUnitAndTem(params) {
    return request({
        url: "/rate/bindingUnitAndTem",
        method: "post",
        params,
    });
}